import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Card, Col, Form, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';
import {
    updateEverything
} from '../actions/index';
import {
    EMPLOYEE_COUNT,
    OVERRIDE_POINTS,
    NO_CALL_OFF_POINTS,
    NO_CALL_OFF_SHIFTS,
    ON_TIME_POINTS,
    PARTICIPATION,
    QUARTERLY,
    REWARD_BUDGET,
    REWARD_VALUE,
    SHIFTS_PICKED_UP,
    SURVEY
} from '../actions/types';
import _ from 'lodash';

class SaveLoad extends Component {

    constructor(props) {
        super(props);
        this.state = {
            save: '',
            saveMessage: ''
        };
    }

    buttonSaveClick() {
        // eslint-disable-next-line
        console.log(this.state);
        try {
            const loadProps = JSON.parse(this.state.save);
            // eslint-disable-next-line
            console.log(loadProps);
            const update = {};
            _.forEach(loadProps, (value, key) => {
                update[key] = Number(value);
            });
            this.props.updateEverything(update);
            this.setState({saveMessage: 'Load data appeared to work, look at the calculate page for confirmation.'});
        }
        catch (e) {
            // eslint-disable-next-line
            console.log(e);
            this.setState({saveMessage: 'Something was wrong with the load data, sorry.'});
        }
    }
    /* eslint-disable-line */ //simpliest way to perserve the spacing when displayed without violatiing eslint rules.
    render() {
        const { employeeCount, overridePoints, participation, rewardBudget, rewardValue,
            noCallOffPoints, noCallOffShifts, onTimePoints, quarterly, survey } = this.props;
        return (
            <Row>
                <Col md={12}>
                    <Card>
                        <Card.Header><h3>Save configuration</h3></Card.Header>
                        <p className='config-header'>Save the following text in a document for later use in reloading this exact configuration</p>
                        <Card.Body className='config-container'>
                            <Card className='config-card'>
                                <pre>
                                    {`{
    "EMPLOYEE_COUNT": "${employeeCount}",
    "OVERRIDE_POINTS": "${overridePoints}",
    "NO_CALL_OFF_POINTS": "${noCallOffPoints}",
    "NO_CALL_OFF_SHIFTS": "${noCallOffShifts}",
    "ON_TIME_POINTS": "${onTimePoints}",
    "PARTICIPATION": "${participation}",
    "QUARTERLY": "${quarterly}",
    "REWARD_BUDGET": "${rewardBudget}",
    "REWARD_VALUE": "${rewardValue}",
    "SURVEY": "${survey}"
}`}
                                    {/* Temporarily commented out for 0.8.2
                                    "SHIFTS_PICKED_UP": "${shiftsPickedUp}",
                                    */}
                                </pre>
                            </Card>
                        </Card.Body>
                    </Card>
                    <Card className='load-config-card'>
                        <Card.Header><h3>Load configuration</h3></Card.Header>
                        <p className='config-header'>Paste text similar to the above into this text area and save to load a previous configuration, include the curly braces.</p>
                        <Card className='config-container'>
                            <Form.Group className='config-card'>
                                <Form.Control
                                    className='load-config-form'
                                    as="textarea"
                                    onChange={(event) => {this.setState({save: event.target.value});}}>
                                </Form.Control>
                            </Form.Group>
                        </Card>
                        <span className='load-btn'><Button variant='default' onClick={() => this.buttonSaveClick()}>Attempt to load saved config</Button></span>
                        <p>{this.state.saveMessage}</p>
                    </Card>
                </Col>
            </Row>
        );
    }
}

SaveLoad.propTypes = {
    employeeCount: PropTypes.number,
    overridePoints: PropTypes.number,
    noCallOffPoints: PropTypes.number,
    noCallOffShifts: PropTypes.number,
    onTimePoints: PropTypes.number,
    participation: PropTypes.number,
    quarterly: PropTypes.number,
    rewardBudget: PropTypes.number,
    rewardValue: PropTypes.number,
    survey: PropTypes.number,
    updateEverything: PropTypes.func
};

function mapStateToProps(state) {
    return {
        employeeCount: state.calc.get(EMPLOYEE_COUNT),
        overridePoints: state.calc.get(OVERRIDE_POINTS),
        noCallOffPoints: state.calc.get(NO_CALL_OFF_POINTS),
        noCallOffShifts: state.calc.get(NO_CALL_OFF_SHIFTS),
        onTimePoints: state.calc.get(ON_TIME_POINTS),
        participation: state.calc.get(PARTICIPATION),
        quarterly: state.calc.get(QUARTERLY),
        rewardBudget: state.calc.get(REWARD_BUDGET),
        rewardValue: state.calc.get(REWARD_VALUE),
        shiftsPickedUp: state.calc.get(SHIFTS_PICKED_UP),
        survey: state.calc.get(SURVEY),
    };
}

export default connect(mapStateToProps, {
    updateEverything
})(SaveLoad);
